import $ from 'jquery';
import ResultBox from './ResultBox';
import { useState } from 'react';
import styles from "./ResultPage.module.css";

const ResultsPage = (props) => {

    let resultList = [];

    let truth_percentage = 0;
    let true_facts = 0;
    let false_facts = 0;

    props.resultArray.forEach(result => {
        resultList.push(<ResultBox obj = {result}/>);
        if(result['truth_value'] === "True") {
            true_facts++;
        }
        else {
            false_facts++;
        }
    });
    truth_percentage = parseInt(true_facts / (true_facts + false_facts) * 100);
    
    return(
        <div className = {styles.body}>
            <h1 id = "loading" className = {styles.results_title}>Results</h1>
            <p className = {styles.percentage}>The video has {truth_percentage}% true facts.</p>
            {resultList}
        </div>
    )
}

export default ResultsPage;